<template>
  <div>
    <div
      class="block block-rounded question-container"
      style="border: 1px solid #f8f9f9;"
      :id="'question-container-' + identifier"
    >
      <div class="block-header">
        <h3 class="block-title d-flex justify-content-center">Ajoutez votre question</h3>
        <div class="block-options">
          <button type="button" @click="remove" class="btn btn-alt-danger me-1 rounded-circle">
            <i class="fa fa-fw fa-trash"></i>
          </button>
          <button type="button" @click="hide" class="btn btn-alt-success ms-2 rounded-circle">
            <i v-if="opened" class="fa fa-fw fa-chevron-up"></i>
            <i v-else class="fa fa-fw fa-chevron-down"></i>
          </button>
        </div>
      </div>
      <div ref="content" class="block-content block-content-full">
        <div class="row justify-content-center py-md-3 py-lg-5">
          <div class="col-12">
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="">
                  <label class="form-label" for="question">Votre question</label>
                  <input
                    type="text"
                    class="question form-control "
                    id="question"
                    :disabled="question.is_disabled == true"
                    :name="'form-' + identifier + '[question]'"
                    placeholder="ex: Comment avez vous trouvé votre prestation?"
                    v-model="question.question"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="">
                  <div class="switch-button-question form-check form-switch">
                    <input
                      class="switch_client form-check-input"
                      type="checkbox"
                      :id="'switch-client-' + identifier"
                      :name="'form-' + identifier + '[switch_client]'"
                      :checked="question.is_in_customer_card"
                      @input="showQuestion()"
                    />
                    <label class="form-check-label" :for="'switch-client-' + identifier">Lié à la fiche client</label>
                  </div>
                </div>
              </div>
              <!-- Commenté: inutilisable pour le moment -->
              <!-- <div class="col-12 col-md-3">
                <div :id="'container-categoy-' + identifier" class="container-answer-category col-12">
                  <label class="form-label" for="category">Si categorie</label>
                  <select
                    :disabled="question.is_disabled == true"
                    class="form-select category"
                    :id="'form-select-category-' + identifier"
                    :name="'form-' + identifier + '[category]'"
                    v-model="optionCategory"
                  >
                    <option value="0">-- Aucune --</option>
                    <option v-for="(item, i) in categories" :key="i" :value="item.id">{{ item.name }}</option>
                  </select>
                </div>
              </div>
              <div class="col-12 col-md-3">
                <div :id="'container-no_category-' + identifier" class="container-answer-no_category col-12">
                  <label class="form-label" for="no_category">Si pas categorie</label>
                  <select
                    :disabled="question.is_disabled == true"
                    class="form-select no_category"
                    :id="'form-select-no_category-' + identifier"
                    :name="'form-' + identifier + '[no_category]'"
                    v-model="optionNotCategory"
                  >
                    <option value="0">-- Aucune --</option>
                    <option v-for="(item, i) in categories" :key="i" :value="item.id">{{ item.name }}</option>
                  </select>
                </div>
              </div> -->
            </div>
            <div class="row mb-4">
              <div :id="'container-answer-' + identifier" class="container-answer col-12">
                <label class="form-label" for="type">Type de la réponse</label>
                <select
                  :disabled="question.is_disabled == true"
                  class="form-select type"
                  :id="'form-select-' + identifier"
                  :name="'form-' + identifier + '[type]'"
                  v-model="optionValue"
                >
                  <option value="0">Choix multiple</option>
                  <option value="1">Choix unique</option>
                  <option value="2">Choix libre (caractères)</option>
                  <option value="3">Choix libre (chiffres)</option>
                </select>
              </div>

              <div
                :id="'answers-' + identifier"
                v-if="
                  question.answers_possibilities.length != 0 && question.type != null && (optionValue == 0 || optionValue == 1)
                "
              >
                <label
                  class="form-label mt-4"
                  for="answers"
                  v-if="question.type != null && (question.type == 0 || question.type == 1)"
                  >Possibilités de réponse</label
                >
                <div
                  class="d-flex mb-2 flex-wrap"
                  :id="'answers-container-' + index + '-form-' + identifier"
                  v-for="(possibility, index) in question.answers_possibilities"
                  :key="index"
                >
                  <input
                    v-if="parentQuestion"
                    type="hidden"
                    :name="'form-' + identifier + '[parentQuestion]'"
                    :value="parentQuestion + '$' + parentPossitility"
                  />

                  <input
                    type="text"
                    :disabled="question.is_disabled == true"
                    :name="'form-' + identifier + '[possibilities][]'"
                    class="form-control col-4 "
                    v-model="question.answers_possibilities[index].possibility"
                    :id="'answer' + index"
                  />

                  <i
                    v-if="question.is_disabled == false"
                    @click="deleteAnswer(index)"
                    class="d-flex align-items-center text-danger fa fa-fw fa-trash me-1 ms-2"
                  ></i>

                  <select
                    :disabled="question.is_disabled == true"
                    v-if="question.is_disabled == false"
                    class="form-select col-3 ml-3 type"
                    :id="'form-select-' + identifier"
                    :name="'form-' + identifier + '[possibilities_tag_categories][]'"
                  >
                    <option value="" selected>Aucun tag lié</option>
                    <optgroup label="Catégories">
                      <option
                        :selected="includes(question.answers_possibilities[index].tag_categories, tagCategory.id)"
                        v-for="tagCategory in tagcategories"
                        v-bind:key="tagCategory.id"
                        :value="tagCategory.id"
                        >{{ tagCategory.name }}
                      </option>
                    </optgroup>
                  </select>
                  <select
                    :disabled="question.is_disabled == true"
                    v-if="question.is_disabled == false"
                    class="form-select col-3 ml-3 type"
                    :id="'form-select-' + identifier"
                    :name="'form-' + identifier + '[possibilities_tags][]'"
                  >
                    <option value="" selected>Aucun tag lié</option>
                    <optgroup label="Tags">
                      <option
                        :selected="includes(question.answers_possibilities[index].tags, tag.id)"
                        v-for="tag in prestations"
                        v-bind:key="tag.id"
                        :value="tag.id"
                        >{{ tag.name }}
                      </option>
                    </optgroup>
                  </select>

                  <button type="button" @click="addSubQuestion(index)" class="btn btn-success ms-2 text-white">
                    <i class="fa fa-fw fa-plus"></i>
                  </button>

                  <div
                    style="margin-top: 15px; width: 90%"
                    v-if="(possibility.related_questions ? possibility.related_questions.length : 0) !== 0"
                  >
                    <div id="question-component" class="question-component">
                      <survey-question
                        @delete-event="deleteHandler"
                        @up-event="upHandler"
                        @low-event="lowHandler"
                        :prestations="prestations"
                        :tagcategories="tagcategories"
                        v-for="(relatedQuestion, index) in possibility.related_questions"
                        :key="index"
                        :question="relatedQuestion"
                        :identifier="question.id + '' + possibility.id + Math.random()"
                        :parentQuestion="question.question"
                        :parentPossitility="possibility.possibility"
                      ></survey-question>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="question.is_disabled == false" class="d-flex justify-content-between">
              <div>
                <div
                  :id="'button-container-form-' + identifier"
                  v-if="optionValue == 0 || optionValue == 1"
                  class="button-container-form d-flex justify-content-start"
                >
                  <div>
                    <button
                      :id="'add-button-form-' + identifier"
                      @click="addAnswer"
                      type="button"
                      class="add-button-form btn btn-success ms-1 mb-3 text-white"
                    >
                      <i class="fa fa-fw fa-plus me-1 "></i>
                      <span>
                        Ajouter une nouvelle réponse
                      </span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="text-danger">
                <button
                  :id="'delete-question-form-' + identifier"
                  type="button"
                  class="delete-question-form btn btn-outline-danger me-1 mb-3"
                  @click="deleteQuestion"
                >
                  <i class="fa fa-fw fa-trash me-1"></i>
                  <span>
                    Supprimer la question
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <input type="hidden" :name="'form-' + identifier + '[id]'" :value="question.id" />
  </div>
</template>

<script>
export default {
  name: 'SurveyQuestion',
  props: ['question', 'identifier', 'prestations', 'tagcategories', 'parentQuestion', 'parentPossitility', 'categories'],
  data: function() {
    return {
      // Commenté : cause erreur console, inutilisable pour le moment
      //   optionNotCategory: this.question.question_have_categories[0] ? this.question.question_have_categories[0].id : 0,
      //   optionCategory: this.question.question_have_not_categories[0] ? this.question.question_have_not_categories[0].id : 0,
      index: 0,
      currentAnswer: '',
      opened: true,
    }
  },
  mounted() {
    if (typeof this.question === 'number') {
      this.identifier = this.question
    }
  },
  computed: {
    optionValue: function() {
      return this.question.type
    },
  },
  methods: {
    includes(collection, value) {
      try {
        let found = false

        collection.forEach(element => {
          if (element.id === value) {
            found = true
            return true
          }
        })

        return found
      } catch (e) {
        return false
      }
    },

    hide() {
      if (this.opened) {
        this.opened = false
        this.$refs.content.style.height = 0
        this.$refs.content.style.padding = 0
        this.$refs.content.style.overflow = 'hidden'
      } else {
        this.opened = true
        this.$refs.content.style.height = 'initial'
        this.$refs.content.style.padding = '1.25rem'
        this.$refs.content.style.overflow = 'visible'
      }
    },

    remove() {
      this.$destroy()
      this.$el.parentNode.removeChild(this.$el)
    },

    addAnswer() {
      this.question.answers_possibilities.push({
        created_at: new Date(),
        form_id: this.identifier,
        possibility: this.currentAnswer,
        question_id: this.index,
        related_questions: [],
        updated_at: new Date(),
      })
      this.$forceUpdate()
      this.index++
      this.$forceUpdate()
    },

    deleteAnswer(index) {
      this.question.answers_possibilities.splice(index, 1)
      this.$forceUpdate()
    },

    addSubQuestion(index) {
      const empty_question = {
        answers_possibilities: [],
        prestations: [],
        created_at: new Date(),
        id: this.question.answers_possibilities[index].related_questions.length,
        is_in_customer_card: false,
        question: '',
        is_disabled: 0,
        survey_id: 1,
        type: '0',
        updated_at: new Date(),
      }
      this.question.answers_possibilities[index].related_questions.push(empty_question)
    },

    showQuestion() {
      this.question.is_in_customer_card = !this.question.is_in_customer_card
      this.$forceUpdate()
    },
    upClickHandler() {
      this.$emit('up-event', this.identifier)
    },
    lowClickHandler() {
      this.$emit('low-event', this.identifier)
    },

    deleteQuestion() {
      this.$emit('delete-event', this.identifier)
    },

    upHandler(index) {
      if (index >= 1) {
        const a = this.questions[index]
        const b = this.questions[index - 1]
        this.questions[index] = b
        this.questions[index - 1] = a
        this.$forceUpdate()
      }
    },
    lowHandler(index) {
      console.log(this.questions)
      if (index < this.questions.length - 1) {
        const a = this.questions[index]
        const b = this.questions[index + 1]
        this.questions[index] = b
        this.questions[index + 1] = a
        this.$forceUpdate()
      }
    },
    deleteHandler(index) {
      this.questions.splice(index, 1)
      this.$forceUpdate()
    },
  },
}
</script>
